// Google Tag Manager：僅在打包目標 API 為 https://api.aifly.com.tw 時載入（test / prod 皆指向此域名）
// staging（feibi.site）與本地 development 不載入，避免測試/開發流量污染正式分析數據
const GTM_ID = 'GTM-MWFKPCMS'
const GTM_ENABLED_API_BASE_URL = 'https://api.aifly.com.tw'

export function initGtm() {
  if (import.meta.env.VITE_API_BASE_URL !== GTM_ENABLED_API_BASE_URL) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.prepend(noscript)
}
